<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/D0rvcz/tc-custom/9780830877737.jpg?1692134991151?1696032477531" alt="This image is the cover for the book Who You Are When No One's Looking"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who You Are When No One's Looking
      </h1>
      <p class="bookDescription body article font2">
        <p>We are all at our best when it counts.  But what are we like when no one's looking?  That's where character comes in—being consistent even when it doesn't seem to matter. Courage.  Discipline.  Vision.  Endurance.  Love.  These character qualities are quickly becoming endangered.  All too often we hear of marriages falling apart, governments lying, businesses cheating and scandals rocking the church.  But with God's guidance and strength, we can maintain character that lasts despite temptations and troubles.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bill Hybels
      </h2>
      
      <p class="authorDescription body article"><p><em>Honest to God, Becoming a Contagious Christian, Making Life Work, Too Busy Not to Pray, Just Walk Across the Room, Holy Discontent, Courageous Leadership</em><em>Who You Are When No One's Looking.</em></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?035bb636